export enum UserRoleType {
    ADMIN = 'ADMIN',
    OPERATOR = 'OPERATOR',
    VIEWER = 'VIEWER',
    ANALYST = 'ANALYST',
    OWNER = 'OWNER',
    SUPERADMIN = 'SUPERADMIN'
}